import { TOKEN_RDSTATION, URL_RDSTATION } from '../util/constants';

/* eslint-disable no-param-reassign */
function FormNewsletterController($http, $timeout) {
  const vm = this;

  vm.isSuccess = false;
  vm.isSubmiting = false;

  vm.send = form => {
    vm.errors = null;

    // Valida o formulário
    if (form.$invalid) {
      // Ativa os erros nos inputs formulário
      vm.isError = true;
      form.$dirty = true;
      form.$$controls.forEach((_, idx) => {
        form.$$controls[idx].$dirty = true;
      });

      return;
    }

    const request = {
      token_rdstation: TOKEN_RDSTATION,
      identificador: vm.formid,
      email: form.email.$modelValue,
      nome: form.name.$modelValue,
      website: 'setpar.com.br',
      legal_bases: [
        {
          category: 'communications',
          type: 'consent',
          status: 'granted',
        },
      ],
      tags: vm.tags ? vm.tags.split(',') : [],
    };

    const urlPost = URL_RDSTATION;
    const errorDefault =
      'Um erro inesperado o ocorreu, tente novamente mais tarde';

    vm.isSubmiting = true; // exibe o loading

    $http({
      url: urlPost,
      method: 'POST',
      data: request,
    })
      .then(response => {
        vm.isSubmiting = false; // Esconde o loading
        if (response.status === 200) {
          vm.isSuccess = true; // Exibe msg de sucesso

          form.$setPristine();
          form.$setUntouched();
          form.email.$$setModelValue();
          form.name.$$setModelValue();

          $timeout(() => {
            vm.isSuccess = false; // esconde msg de sucesso apos 2000ms
          }, 5000);
        } else if (response.data && response.data.error) {
          vm.errors = response.data.error;
        } else {
          vm.errors = errorDefault; // exibe msg de erro padrão
        }
      })
      .catch(error => {
        vm.isSubmiting = false; // esconde o loading
        vm.errors = errorDefault; // exibe msg de error padrão
        console.error(error);
      });
  };
}

export default FormNewsletterController;
